import navigationMobile from './navigation-mobile';
import navigationDefault from './navigation-default';
import { defineStore } from 'pinia';

export const useNavigationStore = defineStore('navigation', {
  state: () => ({
    active: null,
    mode: null,
    items: [],
    subItems: []
  }),
  actions: {
    loadItems(mode) {
      if (mode === this.mode) {
        return;
      }
      this.mode = mode;
      this.items = mode === 'mobile' ? navigationMobile : navigationDefault;
    }
  }
});
